<template>
  <div v-if="article">
    <h3 class="my-4"><strong>{{article.title}}</strong></h3>
    <div>
      <div class="my-3">
        <mdb-icon icon="user"/> {{article.writer && article.writer.name}}
        <mdb-icon icon="eye" class="ml-4"/> {{article.readCount}}
        <mdb-icon icon="clock" class="ml-4" /> {{$moment(article.regDate).format('YYYY-MM-DD')}}
        <hr/>
        <div v-if="article.attach &&  article.attach.length">
          <mdb-icon icon="paperclip" /> 첨부파일: <br/>
          <div class="ml-4">
            <span v-for="(file, index) in article.attach" :key="index" class="pointer" @click="download(file)">
              <mdb-icon far icon="save" /> {{file.orgFile}}<br/>
            </span>
          </div>
        </div>
      </div>
      <div v-html="article.content"></div>
    </div>
  </div>
</template>
<script>
import { mdbIcon } from 'mdbvue';
import { mapState } from 'vuex';
export default {
  name: 'Article',
  components: { mdbIcon },
  props: ['article'],
  computed: {
    ...mapState('training', ['training'])
  },
  methods: {
    async download (file) {
      const url = `/api/download/${this.training._id}/${this.article.category}/${file.file}/${file.orgFile}`
      this.$download(url, file.orgFile)
    }
  }
}
</script>
